import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationService } from './authentication.service';

export const authGuard: CanActivateFn = (route, state) => {
  const msalService = inject(MsalService);
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  const activeAccount = msalService.instance.getActiveAccount();

  if (!activeAccount) {
    authService.loginRedirect();
    return false;
  }

  return true;
};

export const writeAccessGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  const user = authService.getUserValue();

  if (!user?.authorization.write) {
    router.navigate(['/unauthorized']);
    return false;
  }

  return true;
};
